import { Box } from '@mui/joy'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-scroll'
import { Wrapper } from './styled'

type Label = {
  label: string
  labelI18n?: never
}

type LabelI18n = {
  label?: never
  labelI18n: ParseKeys
}

export type QuickNavigationOption = (Label | LabelI18n) & {
  anchor: string
}

export type QuickNavigationOptions = QuickNavigationOption[]

type QuickNavigationProps = {
  options: QuickNavigationOptions
}

export function QuickNavigation({ options }: QuickNavigationProps) {
  const { t } = useTranslation()

  return (
    <>
      <Box sx={{ marginBottom: '88px' }} />
      <Wrapper direction='row' spacing={1}>
        {options.map(({ label, labelI18n, anchor }) => (
          <Link
            key={anchor}
            to={anchor}
            smooth={true}
            spy
            duration={500}
            offset={-110}
          >
            {label ?? t(labelI18n)}
          </Link>
        ))}
      </Wrapper>
    </>
  )
}
